import {
  SET_START_TIME,
  SET_USERNAME,
  SET_PASSWORD,
  TOGGLE_HAS_SELECTED_STAY_LOGGED_IN,
  SET_ERROR_TEXT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE
} from 'constants/actionTypes';

const initialState = {
  errorText: '',
  hasSelectedStayLoggedIn: true,
  isFetching: false,
  password: '',
  passwordConfirm: '',
  startTime: null,
  username: ''
};

/**
 * Login reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case SET_START_TIME:
      return {
        ...state,
        startTime: Date.now()
      };

    case SET_USERNAME:
      return {
        ...state,
        username: action.value.trim()
      };

    case SET_PASSWORD:
      return {
        ...state,
        password: action.value
      };

    case TOGGLE_HAS_SELECTED_STAY_LOGGED_IN:
      return {
        ...state,
        hasSelectedStayLoggedIn: !state.hasSelectedStayLoggedIn
      };

    case SET_ERROR_TEXT:
      return {
        ...state,
        errorText: action.errorText
      };

    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        errorText: action.errorText,
        isFetching: false
      };

    default:
      return state;
  }
}
